import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

import * as utils from './utils'

/**
 * Submits edits through the mutations plugin
 */
export const submitEdits = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    feature.actions.submit.relay((forwardTo, selection) =>
      utils.findEdits(selection, plugin).pipe(
        rxjs.mergeMap(foundEdits => {
          const forwardActions = []

          if (foundEdits.creations.length) {
            forwardActions.push(
              forwardTo(
                plugin.collection.plugins.dataOperationPlugin.feature.actions
                  .create,
                {
                  input: {
                    inputs: foundEdits.creations.map(({ data }) => data),
                  },
                  output: () => foundEdits,
                },
              ),
            )
          }
          if (foundEdits.updates.length) {
            forwardActions.push(
              forwardTo(
                plugin.collection.plugins.dataOperationPlugin.feature.actions
                  .update,
                {
                  input: foundEdits.updates.map(({ id, data }) => ({
                    id,
                    updates: data,
                  })),
                  output: () => foundEdits,
                },
              ),
            )
          }
          if (foundEdits.deletions.length) {
            forwardActions.push(
              forwardTo(
                plugin.collection.plugins.dataOperationPlugin.feature.actions
                  .delete,
                {
                  input: { ids: foundEdits.deletions },
                  output: () => foundEdits,
                },
              ),
            )
          }

          return rxjs.from(forwardActions)
        }),
      ),
    ).asObservable,
)
